import { render, staticRenderFns } from "./meet-affairs-list.vue?vue&type=template&id=b2e17b66&scoped=true&"
import script from "./meet-affairs-list.vue?vue&type=script&lang=js&"
export * from "./meet-affairs-list.vue?vue&type=script&lang=js&"
import style0 from "./meet-affairs-list.vue?vue&type=style&index=0&id=b2e17b66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e17b66",
  null
  
)

export default component.exports